import { pokemon, form, version } from './pokemon'
import type from './type'
import state from './state'
import genre from './genre'
import gen from './gen'
import pokedex from './pokedex'

export default {
  pokemon,
  form,
  version,
  type,
  state,
  genre,
  gen,
  pokedex
}